import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Link,
    Typography,
    colors,
    Button
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    header: {
        paddingBottom: 0,
        backgroundColor: 'white'
    },
    content: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0
        }
    },
    description: {
        padding: theme.spacing(2, 3, 1, 3)
    },
    tags: {
        padding: theme.spacing(0, 3, 2, 3),
        '& > * + *': {
            marginLeft: theme.spacing(1)
        }
    },
    learnMoreButton: {
        marginLeft: theme.spacing(2)
    },
    likedButton: {
        color: colors.indigo[600]
    },
    shareButton: {
        marginLeft: theme.spacing(1)
    },
    details: {
        padding: theme.spacing(2, 3)
    }
}));

function ProjectCard({ vendor, className, ...rest }) {
    const classes = useStyles();

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                className={classes.header}
                disableTypography
                subheader={(
                    <Typography variant="body2">
                        {vendor.vendor.data.custentity_be_rfc_sat}
                        {' '}
                        <Link
                            color="textPrimary"
                            component={RouterLink}
                            to="/profile/1/timeline"
                            variant="h6"
                        >
                            {''}
                        </Link>
                        {' '}
                        | {vendor.vendor.data.url}
                    </Typography>
                )}
                title={(
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={9}>
                            <Link
                                color="textPrimary"
                                component={RouterLink}
                                to="/vendors/1/overview"
                                variant="h5"
                            >
                                {vendor.vendor.data.companyname}
                            </Link>
                        </Grid>
                
                        <Grid item xs={6} md={3}>
                            <Typography variant="button" display="block" gutterBottom>
                                EDI: {vendor.vendor.data.edi}
                            </Typography>
                        </Grid>
                  </Grid>
                )}
            />
            <CardContent className={classes.content}>
                <div className={classes.description}>
                    <Typography
                        color="textSecondary"
                        variant="subtitle2"
                    >
                        {vendor.vendor.data.defaultaddress}
                    </Typography>
                    <Divider />
                    { vendor.vendor.data.anticipoProveedor == "pagoAnticipado" ? <Link component={RouterLink} to={`/consultas/anticipos/${vendor.vendor.data.id}`} variant="h6"> <Button variant="contained" color="secondary"> Ver anticipos </Button> </Link> : ''}
                </div>
            </CardContent>                                     
        </Card>
    );
}

export default ProjectCard;
